export default {
  setEventCloseds (state, eventCloseds) {
    state.eventCloseds = eventCloseds
  },

  setEventClosed (state, eventClosed) {
    state.eventClosed = eventClosed
  },

  setName (state, name) {
    state.name = name
  },

  setPlace (state, place) {
    state.place = place
  },

  setYear (state, year) {
    state.year = year
  },

  setMonth (state, month) {
    state.month = month
  },

  setDay (state, day) {
    state.day = day
  },

  setDate (state, date) {
    state.date = date
  },

  setStartHour (state, startHour) {
    state.startHour = startHour
  },

  setStartMinute (state, startMinute) {
    state.startMinute = startMinute
  },

  setFinishHour (state, finishHour) {
    state.finishHour = finishHour
  },

  setFinishMinute (state, finishMinute) {
    state.finishMinute = finishMinute
  },

  setCloseTime (state, closeTime) {
    state.closeTime = closeTime
  },

  setContent (state, content) {
    state.content = content
  },

  setQuizSet (state, quizset) {
    state.quizset = quizset
  }
}
